export default [
  {
    path: '/commission',
    name: 'Commission',
    component: () => import('./index.vue'),
    meta: {
      title: '佣金规则'
    }
  }
];
